/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import { api, type ApiResult } from "./client";

/** Environment facts the console cannot know at build time. */
export type ConsoleConfig = {
  healthieWebUrl: string;
  demoEnabled: boolean;
};

export function consoleConfig(): Promise<ApiResult<ConsoleConfig>> {
  return api<ConsoleConfig>("/v1/console/config");
}
